import {useSelector} from 'react-redux';
import {snackRedux} from './redux';

export const useSnacks = () => {
  return useSelector(snackRedux.selectors.all);
};
